import { number, object, string } from "yup";

export const draftInvoiceValidationSchema = object({
  invoice_amount: number().required().min(1, "Amount must be greater than 0"),
  task_short_name: string().required("Invoice title is required"),
});
